import React from "react";

const ContactHero = () => {
  return (
    <section className="bg-slate-50 overflow-hidden py-20 lg:py-28">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* --- Left Side: Content --- */}
          <div className="relative z-10">
            {/* Decorative Background Blobs */}
            <div className="absolute -top-10 -left-10 w-40 h-40 bg-blue-100 rounded-full mix-blend-multiply filter blur-3xl opacity-70 -z-10"></div>
            <div className="absolute -bottom-10 -left-4 w-40 h-40 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-70 -z-10"></div>

            {/* Badge */}
            <span className="inline-block py-1 px-3 rounded-full bg-blue-50 text-blue-600 text-sm font-semibold tracking-wide uppercase mb-4">
              Get in Touch
            </span>

            {/* Main Title */}
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-slate-900 tracking-tight leading-[1.1] mb-6">
              Contact Us Today <br />
              <span className="text-blue-600">Start Your Project</span>
            </h2>

            <p className="mt-4 text-lg text-slate-600 font-medium max-w-lg leading-relaxed">
              We are ready to help you transform your business with cutting-edge
              technology solutions.
            </p>

            <div className="mt-10">
              <a
                href="#contact-form"
                className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-lg font-bold rounded-lg text-white bg-blue-600 hover:bg-blue-700 shadow-lg hover:shadow-blue-500/30 transition-all transform hover:-translate-y-1"
              >
                Contact Sales
              </a>
            </div>
          </div>

          {/* --- Right Side: Image (Fixed Height) --- */}
          <div className="relative lg:-mr-10">
            {/* Container with Fixed Height instead of Aspect Ratio */}
            <div className="relative w-full h-[350px] sm:h-[450px]">
              {/* Decorative Background Shape */}
              <div className="absolute inset-0 bg-gradient-to-tr from-blue-200 via-blue-500 to-blue-700 rounded-3xl transform rotate-3 opacity-20"></div>

              {/* Main Image */}
              <img
                className="relative w-full h-full object-cover rounded-3xl shadow-2xl transform transition-transform duration-700 hover:scale-[1.02] border-4 border-white"
                src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=1955&q=80"
                alt="Contact Yarqin Tech Hub"
              />

              {/* Floating Badge */}
              <div
                className="absolute bottom-6 -left-6 bg-white p-4 rounded-xl shadow-xl border border-slate-100 flex items-center gap-3 animate-bounce"
                style={{ animationDuration: "3s" }}
              >
                <div className="bg-green-100 p-2 rounded-full text-green-600">
                  <svg
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                </div>
                <div>
                  <p className="text-xs text-slate-500 font-semibold uppercase tracking-wide">
                    Support
                  </p>
                  <p className="text-sm font-bold text-slate-900">
                    24/7 Online
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;
